import moduleSlice from './state'

export default moduleSlice.reducer
